import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { appRouter } from '@route/app.router';
import { store } from '@store/store';
import { StyleApp } from '@style/style.app';
import { ThemeProvider } from '@style/theme.provider';

import { Wrapper } from './app.style';

const App = () => (
  <Provider store={store}>
    <ThemeProvider>
      <StyleApp>
        <Wrapper>
          <RouterProvider router={appRouter} />
        </Wrapper>
      </StyleApp>
    </ThemeProvider>
  </Provider>
);

export default Sentry.withProfiler(App);
